/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const OfferStateEnum = {
    Draft: 'draft',
    Ordered: 'ordered',
    Approved: 'approved',
    Terminated: 'terminated',
    Previous: 'previous'
} as const;
export type OfferStateEnum = typeof OfferStateEnum[keyof typeof OfferStateEnum];


export function instanceOfOfferStateEnum(value: any): boolean {
    for (const key in OfferStateEnum) {
        if (Object.prototype.hasOwnProperty.call(OfferStateEnum, key)) {
            if (OfferStateEnum[key as keyof typeof OfferStateEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function OfferStateEnumFromJSON(json: any): OfferStateEnum {
    return OfferStateEnumFromJSONTyped(json, false);
}

export function OfferStateEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfferStateEnum {
    return json as OfferStateEnum;
}

export function OfferStateEnumToJSON(value?: OfferStateEnum | null): any {
    return value as any;
}

export function OfferStateEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): OfferStateEnum {
    return value as OfferStateEnum;
}

